import { render, staticRenderFns } from "./LatestBillDetails.vue?vue&type=template&id=68cb87f5&"
import script from "./LatestBillDetails.vue?vue&type=script&lang=js&"
export * from "./LatestBillDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports